import {Drawer} from "antd";
import close from "./../../../assets/images/close.svg";
import {clearLocalStorage} from "../../../utils/localStorage";
import {useNavigate} from "react-router-dom";
import {sendMessageToParent} from "../../../utils/helper";
import {pediaLogout} from "../../tatvaPedia/service";
import {trackAccountLogoutResult} from "../../../utils/zymedSessionDiagnostics";
import useStore from "../../../store/useStore";
import {trackZymedEvent, ZYMED_EVENTS} from "../../../utils/zymedAnalytics";

const Logout = ({show, closePopup}: any) => {
    const navigate = useNavigate();

    const {tatvaPediaToken} = useStore();
    const getToken = () =>
        tatvaPediaToken || localStorage.getItem("tatvaPediaToken");
    const token = getToken();

    const onLogout = async () => {
        // Fired on the confirmation, not on the button that opens this sheet: the
        // taxonomy uses it as the session-end marker.
        trackZymedEvent(ZYMED_EVENTS.HOME_LOGOUT_CLICKED);
        sendMessageToParent("logout");
        const res: any = token ? await pediaLogout(token) : undefined;
        trackAccountLogoutResult({
            // pediaLogout returns the body; the backend reports token rejection as status 403 in it.
            pediaLogout: !token ? "skipped_no_token" : res !== undefined && res?.status !== 403 ? "success" : "failed",
            serverMessage: res?.message,
            tokenBefore: token,
        });
        if (res !== undefined) {
            console.log('logged out from pedia');
        }
        clearLocalStorage();
        navigate("/");
    };
    return (
        <Drawer
            placement="bottom"
            onClose={closePopup}
            closeIcon={false}
            open={show}
            height="auto"
            className="rounded-t-2xl overflow-hidden"
            style={{maxWidth: "1280px", margin: "auto"}}
        >
            <div className="flex flex-col h-full">
                <div className="flex justify-between items-center">
                    <div className="font-semibold text-lg">
                        Are you sure you want to log out your account?
                    </div>
                    <img src={close} alt="close" onClick={closePopup}/>
                </div>
            </div>
            <section
                className="flex justify-center gap-5 mt-6 w-full text-base font-medium tracking-normal leading-loose text-center">
                <button
                    className={`overflow-hidden gap-2 self-stretch px-14 py-2 text-indigo-600 bg-white whitespace-nowrap rounded-xl border border-indigo-600 border-solid`}
                    aria-label={"cancel"}
                    onClick={closePopup}
                >
                    Cancel
                </button>
                <button
                    className={`overflow-hidden gap-2 self-stretch px-14 py-2 text-white bg-indigo-600 whitespace-nowrap rounded-xl border border-indigo-600 border-solid`}
                    aria-label={"logout"}
                    onClick={onLogout}
                >
                    Log out
                </button>
            </section>
        </Drawer>
    );
};

export default Logout;